import angular from 'angular';
import 'angular-legacy-sortablejs-maintained';

import CategoryManageModalComponent from './category-manage-modal.cmpt';

export default angular
    .module('application.component.modals.component.category-manage-modal', [
        'ng-sortable'
    ])
    .component(CategoryManageModalComponent.selector, CategoryManageModalComponent);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/category-manage-modal/index.js